
import { isInclude, post, PostConfig, randomNumber } from "@/assets/utils/common";
import { api } from "@/assets/utils/config";
import { defineComponent } from "vue";
import mpPopover from "../../../../../components/mp-popover/mp-popover.vue";
import slideInfo from "../../slide-info/slide-info.vue";
import { Toast } from "vant";
import EvalDetail from "../../eval-detail/eval-detail.vue";

export default defineComponent({
  components: {
    mpPopover,
    slideInfo,
    EvalDetail,
  },

  props: {
    data: {
      type: Object,
    },
    index: {
      type: Number,
      default: 0,
    }
  },

  data() {
    return {
      interval: <any>null,
      evalDetail: <any>null,
      loading: <boolean>false,
      detailPopperIndex: <number>-1,
      itemList: <any>[],
      transitionTime: 0,
    };
  },

  watch: {
    'data'(newVal, _oldVal) {
      this.itemList.push(newVal);

      let t = setTimeout(() => {
        if (this.itemList.length >= 3) this.itemList.splice(0, 1);
        clearTimeout(t);
      }, 600);
    }
  },

  mounted() {
    let type = this.index;
    if (this.index <= 7) type = this.index;
    else if (this.index == 8) type = 1;
    else if (this.index == 9) type = 8;
    else if (this.index == 10) type = 2;
    else if (this.index == 11) type = 9;
    else type = this.index - 12 + 4;

    this.transitionTime = 5 / ((18 / type) * 4);

    this.itemList = [this.data];

    this.getItem();
    if (this.index > 0) {
      this.interval = setInterval(() => {
        this.getItem();
      }, 5000);
    }
  },

  unmounted() {
    clearInterval(this.interval);
  },

  methods: {
    getItem() {
      if (this.detailPopperIndex == -1) this.$emit('getItem');
    },

    handleShowDetail(visible: boolean, item?: any) {
      if (visible) {
        let config: PostConfig = {
          url: api.getEvaluateDetail,
          param: { id: item.id },
        };
        this.loading = true;
        post(config).then((res: any) => {
          this.loading = false;
          if (res.status == 0) {
            this.evalDetail = res.data;
          } else {
            Toast.fail(res.msg);
          }
        });
      } else {
        this.evalDetail = null;
      }
    },

    detailPopperPlacement() {
      let index = this.index;
      if (index == 1) return 'bottom-start';
      else if (index == 7) return 'bottom-end';
      else if (isInclude(index, [2, 3, 4, 5, 6])) return 'bottom';
      else if (index == 8) return 'right-start';
      else if (index == 9) return 'left-start';
      else if (index == 10) return 'right';
      else if (index == 11) return 'left';
      else if (index == 12) return 'top-start';
      else if (index == 18) return 'top-end';
      else return 'top';
    },
  },
});
